module.exports = __webpack_public_path__ + "im-live-add-62cc0ba9.png";